/** 리디렉션 혀용 주소 목록 */
export const ALLOWED_HOSTS = [
  'youngil.cafe24app.com',
  'xn--vj5b40a.com',
  'youngilwest.cafe24app.com',
  'youngileast.cafe24app.com',
  //'example.com',
];